import { rpc } from '@server/infrastructure/rpc'

import { getBearerToken } from '../../authentication'

export const requestPhoneOtp = async (phone: string, bearerToken?: string) => {
  const authorizationToken = bearerToken ?? (await getBearerToken())
  const response = await rpc.api.v1.users.phone.otp.$post(
    { json: { phone } },
    { headers: { Authorization: `Bearer ${authorizationToken}` } },
  )

  if (!response.ok) {
    throw new Error(`Failed to request otp: ${response.status}`)
  }
}

export const validatePhoneOtp = async (phone: string, otp: string, bearerToken?: string) => {
  const authorizationToken = bearerToken ?? (await getBearerToken())
  const response = await rpc.api.v1.users.phone.otp.validate.$post(
    { json: { phone, otp } },
    { headers: { Authorization: `Bearer ${authorizationToken}` } },
  )

  if (!response.ok) {
    throw new Error(`Invalid otp: ${response.status}`)
  }

  return response.json()
}
